import { Typography } from "@mui/material";
import React from "react";
import {
  CartesianGrid,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

function ChartRenderer({ dataLineChart }) {
  const toPersianDigits = (str) => {
    if (!str) return "";
    return str.toString().replace(/\d/g, (d) => "۰۱۲۳۴۵۶۷۸۹"[d]);
  };
  return (
    <ResponsiveContainer width="100%" minHeight="18rem">
      <LineChart
        data={dataLineChart}
        margin={{ top: 5, right: 10, left: 0, bottom: 5 }}
      >
        <CartesianGrid strokeDasharray="3 3" />

        <XAxis
          dataKey="name"
          fontSize="10px"
          angle={10}
          tickMargin={10}
          tickFormatter={(value) => toPersianDigits(value)}
        />

        <YAxis
          tickMargin={40}
          fontSize="13px"
          tickFormatter={(value) => toPersianDigits(value)}
        />

        <Tooltip
          content={({ active, payload }) => {
            if (active && payload?.length) {
              const d = payload[0].payload;
              return (
                <div
                  style={{
                    background: "#fff",
                    padding: 10,
                    border: "1px solid #ccc",
                    borderRadius: 8,
                  }}
                >
                  <Typography color="#3592FB">
                    سفارش جدید: {toPersianDigits(d.value)}
                  </Typography>
                  <Typography color="rgba(154, 64, 224, 1)">
                    خرابی: {toPersianDigits(d.value1)}
                  </Typography>
                  <Typography color="rgba(76, 175, 80, 1)">
                    تجدید ساخت: {toPersianDigits(d.value2)}
                  </Typography>
                  <Typography color="rgba(255, 152, 0, 1)">
                    اصلاحیه: {toPersianDigits(d.value3)}
                  </Typography>
                  <Typography color="#ff0000ab">
                    جمع کل: {toPersianDigits(d.value4)}
                  </Typography>
                </div>
              );
            }
            return null;
          }}
        />

        <Line
          type="monotone"
          dataKey="value"
          stroke="#3592FB"
          activeDot={{ r: 8 }}
        />
        <Line
          type="monotone"
          dataKey="value1"
          stroke="rgba(154, 64, 224, 1)"
          activeDot={{ r: 8 }}
        />
        <Line
          type="monotone"
          dataKey="value2"
          stroke="rgba(76, 175, 80, 1)"
          activeDot={{ r: 8 }}
        />
        <Line
          type="monotone"
          dataKey="value3"
          stroke="rgba(255, 152, 0, 1)"
          activeDot={{ r: 8 }}
        />
      </LineChart>
    </ResponsiveContainer>
  );
}

export default ChartRenderer;
